import React, { useRef } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import { UploadQueueProvider } from './context/UploadQueueContext';
import UploadQueuePanel from './components/UploadQueuePanel';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ClientReviewPage from './pages/ClientReviewPage';

// Global refresh ref — Dashboard registers its loadContents here
export const refreshRef = { current: null };

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ background:'#0d0f18', height:'100vh', display:'flex', alignItems:'center', justifyContent:'center', color:'#6b7280', fontFamily:'Poppins' }}>
      Loading...
    </div>
  );
  return user ? children : <Navigate to="/login" />;
};

const PublicRoute = ({ children }) => {
  const { user } = useAuth();
  return user ? <Navigate to="/dashboard" /> : children;
};

export default function App() {
  return (
    <AuthProvider>
      <UploadQueueProvider>
        <BrowserRouter>
          <Toaster
            position="top-right"
            toastOptions={{
              style: { background:'#1a1d2e', color:'#f8f9fb', border:'1px solid #2a2d3e', fontFamily:'Poppins', fontSize:13 },
              duration: 3000,
            }}
          />
          {/* Upload panel always visible — refresh triggers Dashboard reload */}
          <UploadQueuePanel onRefresh={() => refreshRef.current && refreshRef.current()} />
          <Routes>
            <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
            <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="*" element={<Navigate to="/dashboard" />} />
            <Route path="/review/:token" element={<ClientReviewPage />} />
          </Routes>
        </BrowserRouter>
      </UploadQueueProvider>
    </AuthProvider>
  );
}